
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';
import { requiredBoolean } from './required-boolean.validator';

export function getProjectNachfassenDtoFormGroup() {
return new FormGroup({
    id: new FormControl<number | undefined>(undefined, [Validators.required]),
    numberQualified: new FormControl<string | undefined>(undefined),
    contactId: new FormControl<number | undefined>(undefined),
    contactName: new FormControl<string | undefined>(undefined),
    kundenberaterName: new FormControl<string | undefined>(undefined),
    objectAddress: new FormControl<string | undefined>(undefined),
    statusId: new FormControl<number | undefined>(undefined),
    statusName: new FormControl<string | undefined>(undefined),
    isPlanned: new FormControl<boolean | undefined>(undefined, [requiredBoolean()]),
    priceOffered: new FormControl<number | undefined>(undefined),
    created: new FormControl<string | undefined>(undefined),
    modified: new FormControl<string | undefined>(undefined),
    lastActivity: new FormControl<string | undefined>(undefined),
})
;
}
      